import React from 'react';
import Section from '../components/Section';
import ChipSelect from '../components/ChipSelect';
import TextField from '../components/TextField';

const POSITIVE_OPTIONS = [
  'Great taste',
  'Love the drinks',
  'Good portion size',
  'Fast service',
  'Friendly staff',
  'Good packaging',
  'Will come again',
  'Nothing specific',
];

const NEGATIVE_OPTIONS = [
  'Wait time too long',
  'Order was wrong',
  'Item not available',
  'Packaging leaked',
  'Drink too sweet',
  'Drink not sweet enough',
  'Price too high',
  'Delivery took too long',
  'Nothing to flag',
];

const NO_ISSUE_TAG = 'Nothing to flag';

function S2_CustomerFeedback({ data, onChange, errors }) {
  // Determine whether the mandatory follow-up text field should appear:
  // show it when at least one negative tag is selected AND it is not solely "Nothing to flag"
  const negSelected = data.customer_feedback_neg || [];
  const hasRealNegative =
    negSelected.length > 0 && !negSelected.every((t) => t === NO_ISSUE_TAG);

  return (
    <Section title="Customer feedback">
      <ChipSelect
        label="What positive things did customers say?"
        options={POSITIVE_OPTIONS}
        selected={data.customer_feedback_pos || []}
        onChange={(v) => onChange('customer_feedback_pos', v)}
      />

      <ChipSelect
        label="What complaints or negative feedback came up?"
        options={NEGATIVE_OPTIONS}
        selected={negSelected}
        onChange={(v) => onChange('customer_feedback_neg', v)}
      />

      {/* MODIFIED — mandatory follow-up if any real negative tag selected */}
      {hasRealNegative && (
        <TextField
          label="Describe the feedback briefly — what did the customer say, and how was it handled?"
          value={data.negative_feedback_detail || ''}
          onChange={(v) => onChange('negative_feedback_detail', v)}
          multiline
          maxLength={500}
          required
          hasError={!!errors.negative_feedback_detail}
          errorMsg={errors.negative_feedback_detail}
          placeholder="e.g. Customer said the wait was over 20 minutes — we apologised and offered a free topping"
        />
      )}

      <TextField
        label="Any other customer feedback?"
        value={data.feedback_notes || ''}
        onChange={(v) => onChange('feedback_notes', v)}
        multiline
        maxLength={300}
        placeholder="Optional — add any details here"
      />
    </Section>
  );
}

export default S2_CustomerFeedback;
